module.exports = __webpack_public_path__ + "static/bud-bowl-7fad09f7fb4dd2675cb32ecc85127819.jpg";